"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Checkbox = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Checkbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (e) {
      var checked = e.target.checked;

      _this.setState({
        checked: checked
      });

      _this.props.onChange && _this.props.onChange(e, _this.props.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          color = _this$props.color,
          disabled = _this$props.disabled,
          indeterminate = _this$props.indeterminate,
          value = _this$props.value,
          className = _this$props.className,
          label = _this$props.label,
          helperText = _this$props.helperText;

      var checkbox = /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        id: id,
        checked: _this.state.checked,
        color: color,
        disabled: disabled,
        indeterminate: indeterminate,
        onChange: _this.onChange,
        value: value,
        className: (0, _classnames.default)("prmbl-checkbox", className)
      });

      return label ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
        id: id ? "".concat(id, "-label") : undefined,
        control: checkbox,
        label: label
      }), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id,
        helperText: helperText
      })) : checkbox;
    });
    _this.state = {
      checked: Boolean(props.checked)
    };
    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      // Override local state if its different.
      if (this.props.checked != null && this.props.checked !== this.state.checked) {
        this.setState({
          checked: this.props.checked
        });
      }
    }
  }]);
  return Checkbox;
}(_react.Component);

exports.Checkbox = Checkbox;
(0, _defineProperty2.default)(Checkbox, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * If `true` the checkbox is checked
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Color for the checkbox
   */
  color: _propTypes.default.oneOf(["default", "primary", "secondary"]),

  /**
   * If `true` the checkbox is disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true` the checkbox is selected with the indeterminate icon `-`
   */
  indeterminate: _propTypes.default.bool,

  /**
   * Callback for the checkbox is clicked
   *
   * Signature: `function(event, checked) => void`
   * event: the originating event.
   * checked: the checked value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * The value to put on the checkbox input.
   *
   * value="Green"
   *  equals:
   * event.target.value = "Green"
   */
  value: _propTypes.default.string,

  /**
   * The text to be used in the label.
   */
  label: _propTypes.default.string,

  /**
   * The text to display for input help/hints
   */
  helperText: _propTypes.default.string
});
(0, _defineProperty2.default)(Checkbox, "defaultProps", {
  className: ""
});
var _default = Checkbox;
exports.default = _default;